import React from 'react';
import { List, ListItem, ListItemText, Divider } from '@material-ui/core';

interface Props {
  genreSearchString: string;
  genresFromSearch: any[];
  handleGenreClicked: (genre: any) => void;
}

export const GenreSearchList = (props: Props) => {
  return (
    <List dense disablePadding className="centeredVertical">
      {props.genreSearchString.length > 0
        ? props.genresFromSearch.map((genre: any, index) => {
            if (index < 5)
              return (
                <div className="genreListItem" key={index} style={{}}>
                  <ListItem key={index} onClick={() => props.handleGenreClicked(genre)}>
                    <ListItemText style={{ color: 'white' }}>{genre}</ListItemText>
                  </ListItem>
                  <Divider />
                </div>
              );
          })
        : null}
    </List>
  );
};
